import { useRouter } from 'next/router';

const useIsAdmin = () => useRouter()?.query?.admin === '1';

export default useIsAdmin;
